import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IResultsRepository } from "@domain/repositories/IResultsRepository";
import { FileMetadata } from "@domain/schemas/BI";

@injectable()
export class DownloadResultsService {
  @inject(TYPES.IResultsRepository)
  private _resultsRepository!: IResultsRepository;

  async getDownloadURL(jobId: string, selectedFiles?: string[]) {
    return this._resultsRepository.downloadFromS3(jobId, selectedFiles);
  }

  async getStepDownloadURL(jobId: string, jobPipelineStepId: string, selectedFiles?: string[]) {
    return this._resultsRepository.downloadStepArtifacts(jobId, jobPipelineStepId, selectedFiles);
  }

  async getBatchDownloadURL(jobId: string, jobPipelineStepId: string, batchId: string, selectedFiles?: string[]) {
    return this._resultsRepository.downloadBatchArtifacts(jobId, jobPipelineStepId, batchId, selectedFiles);
  }

  async listJobResultFiles(jobId: string): Promise<FileMetadata[]> {
    return this._resultsRepository.listJobResultFiles(jobId);
  }

  async listStepArtifactFiles(jobId: string, jobPipelineStepId: string): Promise<FileMetadata[]> {
    return this._resultsRepository.listStepArtifactFiles(jobId, jobPipelineStepId);
  }

  async listBatchArtifactFiles(jobId: string, jobPipelineStepId: string, batchId: string): Promise<FileMetadata[]> {
    return this._resultsRepository.listBatchArtifactFiles(jobId, jobPipelineStepId, batchId);
  }
}
